import React from 'react'
import IconHeading from '../../../components/ui/IconHeading'
import CopyToClipboard from '../../../components/function/CopyToClipboard'

function UserInfoMapping(props) {
  return (
    <section className="mt-4 grid w-full gap-4">
      {props.userInfo.map((row, index) => (
        <div key={index} className="grid grid-cols-3 gap-12">
          {row.map((item, i) => (
            <p key={i} className="flex items-center gap-1 text-sm font-light">
              <span className="font-bold">{item.label}</span>{' '}
              {item.value || '--'}
              {item.hasCopy && <CopyToClipboard value={item.value} />}
            </p>
          ))}
        </div>
      ))}
    </section>
  )
}

function formatUserInfo(userData) {
  return [
    [
      { label: 'Mã người dùng:', value: userData.schoolId, hasCopy: true },
      { label: 'Tên người dùng:', value: userData.fullName },
      { label: 'Khóa:', value: userData.studentCourse },
    ],
    [{ label: 'Email trường:', value: userData.schoolEmail }],
  ]
}

const UserInfo = ({ userData }) => {
  const userInfo = formatUserInfo(userData)
  return (
    <div>
      <IconHeading
        icon="ph:user"
        title="THÔNG TIN CÁ NHÂN"
        className="ml-2 text-lg"
      />
      <UserInfoMapping userInfo={userInfo}></UserInfoMapping>
    </div>
  )
}

export default UserInfo
